export function preparationBgClass(color) {
    if (color) {
        return 'preparation-bg-' + color;
    }
}

export function preparationBorderClass(color) {
    if (color) {
        return 'preparation-border-' + color;
    }
}
